const REASONS = [
  'CANCELED',
  'COMPLAINT',
  'UNCATCHED',
  'UNPAID',
];

const isStandartReasonNotDelivered = (inputReason) => REASONS.includes(inputReason);

export default isStandartReasonNotDelivered;